import { Button } from "@/components/ui/button";
import { m } from "@/paraglide/messages";
import { useStopwatch } from "../hooks/useStopwatch";
import { formatStopwatch } from "../lib/time";
import { TimeDisplay } from "./TimeDisplay";
import { TimerControls } from "./TimerControls";

export function Stopwatch() {
  const sw = useStopwatch();

  const lapButton = (
    <Button
      size="lg"
      variant="secondary"
      onClick={sw.lap}
      disabled={!sw.running}
      className="min-w-28"
    >
      {m.timer_lap()}
    </Button>
  );

  return (
    <div className="pct-card space-y-8 rounded-2xl p-6 sm:p-10">
      <TimeDisplay
        value={formatStopwatch(sw.elapsed)}
        label={m.timer_elapsed_label()}
      />

      <TimerControls
        running={sw.running}
        onStart={sw.start}
        onPause={sw.pause}
        onReset={sw.reset}
        extra={lapButton}
      />

      {sw.laps.length > 0 && (
        <ol className="mx-auto max-w-sm space-y-1">
          {sw.laps.map((lap, i) => {
            const prev = i === 0 ? 0 : sw.laps[i - 1];
            return (
              <li
                key={`${i}-${lap}`}
                className="flex justify-between gap-4 border-b border-border/50 py-1 font-mono text-sm tabular-nums"
              >
                <span className="text-muted-foreground">
                  {m.timer_lap()} {i + 1}
                </span>
                <span>{formatStopwatch(lap - prev)}</span>
                <span className="text-muted-foreground">
                  {formatStopwatch(lap)}
                </span>
              </li>
            );
          })}
        </ol>
      )}
    </div>
  );
}
